<k-area-blocker [showLoader]="_isBusy" [bodyScroll]="true" [classes]="'kAreaBlockerCoverAll'">
  <router-outlet></router-outlet>
</k-area-blocker>
<!--router-outlet></router-outlet-->
<p-confirmDialog
  #confirm
  header="Confirmation"
  [key]="'confirm'"
  [closeOnEscape]="false"
  width="500"
  [class.kAlignToLeft]="_confirmDialogAlignLeft"
  [acceptLabel]="_confirmationLabels.yes"
  [rejectLabel]="_confirmationLabels.no"
>
</p-confirmDialog>
<p-confirmDialog
  #alert
  header="Alert"
  [key]="'alert'"
  [closeOnEscape]="true"
  width="440"
  [class.kAlignToLeft]="_confirmDialogAlignLeft"
>
  <p-footer>
    <button
      type="button"
      pButton
      icon="fa-check"
      label="{{ _confirmationLabels.ok }}"
      (click)="alert.accept()"
    ></button>
  </p-footer>
</p-confirmDialog>

<kPopupWidget #openEmailPopup data-aid="openEmailPopup" [modal]="true" [popupWidth]="500" [popupHeight]="320">
  <ng-template>
    <kOpenEmail [parentPopupWidget]="openEmailPopup" [emailConfig]="_openEmailConfig"></kOpenEmail>
  </ng-template>
</kPopupWidget>

<p-toast></p-toast>
<kPreviewEmbed></kPreviewEmbed>
<kCaptionRequest></kCaptionRequest>
